/* HTML rendering utilities. */

/** Escape HTML's tag chars. */
export function escapeHtml(unsafe: string | null) {
    if (unsafe === null) {
        return "";
    }
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}
